export const NHS_VTR_CODE_P9 = '[%22P9.Cp.Cd%22]';
export const NHS_VTR_CODE_P5 = '[%22P5.Cp.Cd%22]';
